var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronRightSmall = function SvgChevronRightSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70453 17.2946C8.31526 16.9053 8.31491 16.2743 8.70376 15.8846L12.5799 12L8.70376 8.11538C8.31491 7.72569 8.31526 7.09466 8.70453 6.70538C9.0941 6.31581 9.72572 6.31581 10.1153 6.70538L14.7028 11.2929C15.0933 11.6834 15.0933 12.3166 14.7028 12.7071L10.1153 17.2946C9.72572 17.6842 9.0941 17.6842 8.70453 17.2946Z",
    fill: "currentColor"
  })));
};
export default SvgChevronRightSmall;